import { Component, OnInit } from '@angular/core';
import { ModalController, LoadingController, AlertController, NavParams } from '@ionic/angular';
import * as moment from 'moment';
import { ConnectedAccountService } from '../../services/connected-account.service';
import { SupportedCurrencyService } from 'src/app/services/supported-currency.service';
import { DateTimePickerPage } from './../../modals/date-time-picker/date-time-picker.page';
import { StorageService } from '../../services/storage.service';
import { RegisterService } from '../../services/register.service';
import { UserService } from '../../services/user.service';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-reports-payments-and-refunds-search',
    templateUrl: './reports-payments-and-refunds-search.page.html',
    styleUrls: ['./reports-payments-and-refunds-search.page.scss'],
})

export class ReportsPaymentsAndRefundSearchPage implements OnInit {

    search_params = {};
    moment = moment;
    supported_currencies = null;
    formatted_from_date = null;
    formatted_to_date = null;
    date_modal_css_class = '';
    register_id = null;
    register = null;

    // modal flags
    date_picker_modal_open = false;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public navParams: NavParams,
        public loadingController: LoadingController,
        private storageService: StorageService,
        private connectedAccountService: ConnectedAccountService,
        private supportedCurrencyService: SupportedCurrencyService,
        private registerService: RegisterService,
        private userService: UserService
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.date_modal_css_class = 'backdrop';
        }

        if(this.navParams.get('currency_id')){
            this.search_params['currency_id'] = this.navParams.get('currency_id');
        }
        
        if (this.navParams.get('from_date') || this.navParams.get('to_date')) {
            this.storageService.get("connected_account_id").then((connected_account_id) => {
                if (connected_account_id) {
                    this.connectedAccountService.getConnectedAccount(connected_account_id).then((connected_account: any) => {
                        if (connected_account['user_id']) {
                            this.userService.getUser(connected_account['user_id']).then((user: any) => {
                                if (this.navParams.get("from_date")) {
                                    this.search_params['from_date']= this.moment.utc(this.navParams.get("from_date")).tz(user.timezone.code).toISOString(true);
                                    this.formatted_from_date = this.moment(this.search_params['from_date']).format("D MMM YYYY, HH:mm");
                                }
                                if (this.navParams.get("to_date")) {
                                    this.search_params['to_date'] = this.moment.utc(this.navParams.get("to_date")).tz(user.timezone.code).toISOString(true);
                                    this.formatted_to_date = this.moment(this.search_params['to_date']).format("D MMM YYYY, HH:mm");
                                }
                            });
                        }
                    });
                }
            });
        }

		this.loadSupportedCurrencies().then(() => { }).catch(() => { });

    }

    loadSupportedCurrencies() {
        return new Promise<void>((resolve, reject) => {
            this.supportedCurrencyService.getSupportedCurrencies().then((supported_currencies) => {

                if(supported_currencies) {

                    this.supported_currencies = supported_currencies;

                    this.supported_currencies.sort((a, b) => {
                        if (a['title'].toLowerCase() < b['title'].toLowerCase()) { return -1; }
                        if (a['title'].toLowerCase() > b['title'].toLowerCase()) { return 1; }
                        return 0;
                    });

                    this.storageService.get("register_id").then((register_id) => {

                        if(register_id) {
    
                            this.register_id = register_id;
    
                            this.registerService.getRegister(this.register_id).then((register) => {
    
                                if(register) {
    
                                    this.register = register;
    
                                    for(let i = 0; i < this.supported_currencies.length; i++) {

                                        // NOTE: default currency
                                        if(this.supported_currencies[i].id == this.register['location'].default_currency.id) {
                                            let register_location_default_currency = this.supported_currencies.splice(i, 1)[0];
                                            this.supported_currencies.unshift(register_location_default_currency);
                                            break;
                                        }
    
                                    }
                                }
                            })
                            .catch(() => { });
                        }
                    })
                    .catch(() => { });
                }
                resolve();
            })
            .catch(() => { 
                reject();
            });
        });
    }

    close() {
        this.modalController.dismiss();
    }

    filterOrders() {
        if(this.search_params['from_date']) {
            this.search_params['from_date'] = this.moment(this.search_params['from_date']).utc().toISOString();
        }
        if(this.search_params['to_date']) {
            this.search_params['to_date'] = this.moment(this.search_params['to_date']).utc().toISOString();
        }
        this.modalController.dismiss(this.search_params);
    }

    async presentFromDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.search_params['from_date'] ? this.search_params['from_date'] : ""),
                    format: "date-time",
                    clear_date: false
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    this.search_params['from_date'] = data.data['date'];
                    this.formatted_from_date = this.moment(this.search_params['from_date']).format("D MMM YYYY, HH:mm");
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentToDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.search_params['to_date'] ? this.search_params['to_date'] : ""),
                    format: "date-time",
                    clear_date: false
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    this.search_params['to_date'] = data.data['date'];
                    this.formatted_to_date = this.moment(this.search_params['to_date']).format("D MMM YYYY, HH:mm");
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

}
